<!-- 开关 -->
<template>
    <div v-if="componentsData.type == 5">
        <div class="bg-div" :style="bgStyle">
            <template v-if="componentsData.content.select_style == 1">
                <div v-if="componentsData.content.title" class="title-box" :style="titleStyle">
                    {{ componentsData.content.title }}
                </div>
                <i-switch
                    v-model="componentsData.content.initial_state"
                    :true-value="1"
                    :false-value="2"
                    :true-color="componentsData.content.open_button_color"
                    :false-color="componentsData.content.close_button_color"
                    disabled
                ></i-switch>
            </template>
            <div
                v-if="componentsData.content.select_style == 2"
                class="flex-sb"
            >
                <div :style="titleStyle" class="title-box2">
                    {{ componentsData.content.title }}
                </div>
                <i-switch
                    v-model="componentsData.content.initial_state"
                    :true-value="1"
                    :false-value="2"
                    :true-color="componentsData.content.open_button_color"
                    :false-color="componentsData.content.close_button_color"
                    disabled
                ></i-switch>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    computed: {
        titleStyle() {
            const content = this.componentsData.content;
            return {
                fontSize: `${content.title_size}px`,
                color: content.title_color,
            };
        },
        bgStyle() {
            const content = this.componentsData.content;
            const style = {};
            if (content.bg_color) {
                style.backgroundColor = content.bg_color;
            }
            const bgImg = content.bg_img || {};
            if (bgImg.picview && content.bg_value) {
                style.backgroundImage = `url(${bgImg.picview})`;
            }
            style.padding = `${content.inner_spacing.top}px ${content.inner_spacing.left}px`;
            style.margin = `${content.outer_spacing.top}px ${content.outer_spacing.left}px`;
            style.borderRadius = `${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.bottom}px ${content.rounded_corner_setting.bottom}px`;
            return style;
        },
    },
};
</script>

<style scoped>
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.title-box {
    margin-bottom: 6px;
    font-size: 18px;
}
.title-box2 {
    font-size: 18px;
}
</style>
